"use strict";
function btyPhotoswipeHandle(e = document) {
  let t = function e(t, n) {
      return t && (n(t) ? t : e(t.parentNode, n));
    },
    n = function (e) {
      (e = e || window.event).preventDefault
        ? e.preventDefault()
        : (e.returnValue = !1);
      let n = e.target || e.srcElement,
        i = t(n, function (e) {
          return e.tagName && "BUTTON" === e.tagName;
        });
      if (!i) return;
      let r,
        d = i.parentNode.parentNode,
        a = d.childNodes,
        l = 0;
      for (let e = 0, t = a.length; e < t; e++)
        if (1 === a[e].nodeType && a[e].querySelector("[data-dimension]")) {
          if (a[e] === i.parentNode) {
            r = l;
            break;
          }
          l++;
        }
      return (r >= 0 && o(r, d), !1);
    },
    o = function (t, n, o, i) {
      let r,
        d,
        a,
        l = e.querySelector(".pswp");
      if (
        ((a = (function (e) {
          let t,
            n,
            o,
            i = e.querySelectorAll(".product-main-slide .media-preview-wrap"),
            r = [];
          if (i.length) {
            for (let e = 0, d = i.length; e < d; e++)
              ((t = i[e]),
                "BUTTON" === t.tagName &&
                  ((n = t.getAttribute("data-dimension")),
                  n &&
                    ((n = n.split("x")),
                    (o = {
                      src: t.getAttribute("data-zoom"),
                      w: parseInt(n[0], 10),
                      h: parseInt(n[1], 10),
                      index: e,
                    }),
                    t.children.length > 0 &&
                      (o.msrc = t.children[0].getAttribute("src")),
                    (o.el = t),
                    r.push(o))));
            return r;
          }
        })(n)),
        (d = {
          galleryUID: n.getAttribute("data-pswp-uid"),
          getThumbBoundsFn: function (e) {
            let t = a[e].el.querySelector("img"),
              n = window.pageYOffset || document.documentElement.scrollTop,
              o = t.getBoundingClientRect();
            return { x: o.left, y: o.top + n, w: o.width };
          },
        }),
        i)
      )
        if (d.galleryPIDs) {
          for (let e = 0, n = a.length; e < n; e++)
            if (a[e].pid == t) {
              d.index = e;
              break;
            }
        } else d.index = parseInt(t, 10) - 1;
      else d.index = parseInt(t, 10);
      isNaN(d.index) ||
        (o && (d.showAnimationDuration = 0),
        (r = new PhotoSwipe(l, PhotoSwipeUI_Default, a, d)),
        r.init(),
        r.listen("afterChange", function (e) {
          document.dispatchEvent(
            new CustomEvent("lightbox-product-updatedupdated", {
              detail: { index: r.items[r.getCurrentIndex()].index },
            }),
          );
        }));
    },
    i = e.querySelectorAll(".product-main-slide");
  if (i.length) {
    for (let e = 0, t = i.length; e < t; e++)
      (i[e].setAttribute("data-pswp-uid", e + 1), (i[e].onclick = n));
    let e = (function () {
      let e = window.location.hash.substring(1),
        t = {};
      if (e.length < 5) return t;
      let n = e.split("&");
      for (let e = 0, o = n.length; e < o; e++) {
        if (!n[e]) continue;
        let o = n[e].split("=");
        o.length < 2 || (t[o[0]] = o[1]);
      }
      return (t.gid && (t.gid = parseInt(t.gid, 10)), t);
    })();
    e.pid && e.gid && o(e.pid, i[e.gid - 1], !0, !0);
  }
}
function btyModelExit() {
  document.addEventListener("click", function (e) {
    let t = e.target,
      n = document.querySelector(".product-main-slide")
        ? ".product-main-slide"
        : ".single-media";
    t.closest(n) || btyMediaAction();
  });
}
class ProductModel extends HTMLElement {
  constructor() {
    super();
    const e = this.querySelector('[id^="deferred-poster-"]');
    e && e.addEventListener("click", this.loadContent.bind(this));
  }
  loadContent(e = !0) {
    if (!this.getAttribute("loaded")) {
      const t = document.createElement("div");
      if (this.querySelector("template")) {
        (t.appendChild(
          this.querySelector("template").content.firstElementChild.cloneNode(
            !0,
          ),
        ),
          this.setAttribute("loaded", !0));
        const n = this.appendChild(t.querySelector("model-viewer"));
        e && n.focus();
      }
    }
    Shopify.loadFeatures([
      {
        name: "model-viewer-ui",
        version: "1.0",
        onLoad: this.setupModelViewerUI.bind(this),
      },
    ]);
  }
  setupModelViewerUI(e) {
    e ||
      (this.modelViewerUI = new Shopify.ModelViewerUI(
        this.querySelector("model-viewer"),
      ));
  }
}
function btyToggleModal(e = document) {
  let t = e.querySelectorAll(".modal-toggle-button"),
    n = e.querySelector(".product-modal"),
    o = !!n && n.querySelector(".media-modal-toggle");
  t.length &&
    o &&
    (t.forEach(function (e) {
      e.onclick = function () {
        n.classList.add("is-open");
        let t = n.querySelector(
          '[data-media-id="' +
            e.parentNode.getAttribute("data-media-id") +
            '"]',
        );
        t &&
          (document.documentElement.classList.add("overflow-hidden"),
          t.classList.add("active"));
      };
    }),
    (o.onclick = function () {
      let e = n.querySelector(".product-model.active");
      (e && e.classList.remove("active"),
        n.classList.remove("is-open"),
        document.documentElement.classList.remove("overflow-hidden"));
    }));
}
function btyStickyAddToCart(e = document) {
  let t = e.querySelector(".sticky-add-to-cart");
  if (!t) return;
  let n = t.querySelector(".sticky-product-image"),
    o = t.querySelector(".product-price"),
    i =
      (t.querySelector('[data-type="add-to-cart-form"]'),
      t
        .closest(".shopify-section")
        .querySelector(".summary-item .product-buy")),
    r = t.querySelector('[name="id"]'),
    d = t.querySelector('[name="add"]'),
    a = t.querySelector(".quantity-input"),
    l = t.closest(".shopify-section").querySelector("[data-product-variants]"),
    c = t
      .closest(".shopify-section")
      .querySelector("[data-inventory-quantity]"),
    u = t.querySelectorAll(".field-value"),
    s = {};
  ((l = !!l && btyJsonParse(l.textContent)),
    (c = !!c && btyJsonParse(c.textContent)),
    u.length &&
      u.forEach(function (e) {
        ((s[e.name] = e.value),
          (e.onchange = function () {
            s[e.name] = e.value;
            let t = !!l && btySelectedVariant(s, l);
            if (
              t &&
              (r && (r.value = t.id),
              n &&
                t.featured_image &&
                btyImageLoad(
                  n,
                  t.featured_image.src,
                  t.featured_media.id,
                  n.parentNode,
                ),
              o &&
                (o.innerHTML = btyPriceHtml(
                  t.price,
                  t.compare_at_price,
                  t.unit_price,
                  t.unit_price_measurement,
                )),
              a)
            ) {
              let e = c
                ? c.filter(function (e) {
                    return e.id === t.id;
                  })
                : [];
              if (e.length) {
                let t = e[0].qty;
                t > 0
                  ? (Number(a.value) > t && (a.value = t),
                    a.setAttribute("max", t))
                  : a.removeAttribute("max");
              } else a.removeAttribute("max");
            }
            d &&
              (t
                ? t.available
                  ? ((d.innerHTML = btyStrings.product.add_to_cart),
                    d.classList.remove("disabled"))
                  : ((d.innerHTML = btyStrings.product.out_of_stock),
                    d.classList.add("disabled"))
                : (d.classList.add("disabled"),
                  (d.innerHTML = btyStrings.product.unavailable)));
          }));
      }));
  let m = e.querySelector(".summary-item.add-to-cart");
  if (!m) return;
  const y = function () {
    d.addEventListener("click", function () {
      !window.matchMedia("(min-width: 768px)").matches &&
        d.classList.contains("add-product-variants") &&
        i &&
        i.scrollIntoView({ behavior: "smooth", block: "end", inline: "end" });
    });
  };
  y();
  new IntersectionObserver(function (e) {
    (window.addEventListener("resize", function () {
      y();
    }),
      e[0].intersectionRatio <= 0
        ? t.classList.add("active")
        : t.classList.remove("active"));
  }).observe(m);
}
function btyProductPerformed(e = document) {
  let t = e.querySelectorAll(".product-performed [data-source]");
  t.length &&
    t.forEach(function (e) {
      let t = e.getAttribute("data-url");
      !e.innerHTML.trim() &&
        t &&
        fetch(t)
          .then(function (e) {
            if (200 !== e.status)
              throw (console.log("Status Code: " + e.status), e);
            return e.text();
          })
          .then(function (t) {
            ((e.innerHTML = btyGetSectionHtml(t, "[data-source]")),
              e.removeAttribute("data-url"),
              btyAddToCart(e),
              btyQuickView(e),
              btySwatch(e),
              btyAnimationImageLoad(e),
              btyHoverMediaVideo(e),
              btyQuickAdd(e),
              btyScrollAnimationTrigger(e),
              document.dispatchEvent(new CustomEvent("product-card-updated")));
          })
          .catch(function (e) {
            console.log(e);
          });
    });
}
function btyComplementaryProducts(e = document) {
  let t = e.querySelector(".complementary-products-container");
  if (!t) return;
  let n = t.getAttribute("data-url");
  !t.innerHTML.trim() &&
    n &&
    fetch(n)
      .then(function (e) {
        if (200 !== e.status)
          throw (console.log("Status Code: " + e.status), e);
        return e.text();
      })
      .then(function (e) {
        ((t.innerHTML = btyGetSectionHtml(
          e,
          ".complementary-products-container",
        )),
          btyQuickView(t),
          btySwatch(t),
          btyAnimationImageLoad(t),
          btyAddToCart(t),
          btyAccordionHandle(t));
      })
      .catch(function (e) {
        console.log(e);
      });
}
function btyHandleEmailInputState(e = document) {
  let t = e.querySelector(".email-input"),
    n = e.querySelector(".add-to-cart-button"),
    o = e.querySelector(".error-messages");
  function i() {
    ((n.disabled = "" === t.value.trim()), o && (o.textContent = ""));
  }
  t &&
    n &&
    (i(),
    t.addEventListener("input", i),
    n.addEventListener("click", function () {
      let e = t.value.trim(),
        n = t.dataset.emailRequired;
      /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(e)
        ? o && (o.textContent = "")
        : o && (o.textContent = n);
    }));
}
(customElements.get("product-model") ||
  customElements.define("product-model", ProductModel),
  (window.ProductModel = {
    loadShopifyXR() {
      Shopify.loadFeatures([
        {
          name: "shopify-xr",
          version: "1.0",
          onLoad: this.setupShopifyXR.bind(this),
        },
      ]);
    },
    setupShopifyXR(e) {
      if (e) return;
      if (!window.ShopifyXR)
        return void document.addEventListener("shopify_xr_initialized", () =>
          this.setupShopifyXR(),
        );
      let t = document.getElementById("product-model-config");
      t &&
        (window.ShopifyXR.addModels(JSON.parse(t.textContent)),
        window.ShopifyXR.setupXRElements(),
        t.remove());
    },
  }),
  document.addEventListener("DOMContentLoaded", function () {
    (window.ProductModel && window.ProductModel.loadShopifyXR(),
      btyStickyAddToCart(),
      btyToggleModal(),
      btyPhotoswipeHandle(),
      btyProductPerformed(),
      btyComplementaryProducts(),
      btyHandleEmailInputState(),
      window.addEventListener("resize", function () {
        btyHandleEmailInputState();
      }));
  }),
  // Update main gallery images when variant changes
  document.addEventListener("product-variant-updated", function (ev) {
    try {
      var detail = ev && ev.detail ? ev.detail : null;
      var selected = detail && detail.selected ? detail.selected : null;
      if (!selected) return;
      var media = selected.featured_media || null;
      var src = media && media.preview_image ? media.preview_image.src : (selected.featured_image ? selected.featured_image.src : null);
      if (!src) return;

      var section = document.querySelector(".main-product-section");
      if (!section) return;
      var gallery = section.querySelector(".product-gallery");
      if (!gallery) return;

      // Update all visible gallery preview images to the current variant image
      var imgs = gallery.querySelectorAll(".media-preview");
      if (!imgs.length) return;
      imgs.forEach(function (img) {
        // Remove existing srcset to avoid browser preferring cached sizes
        img.removeAttribute("srcset");
        // Load with cache + loading animation helper
        var wrap = img.parentNode || gallery;
        btyImageLoad(img, src, media ? media.id : selected.id, wrap);
      });
    } catch (e) {}
  }),
  document.addEventListener("shopify:section:load", function (e) {
    let t = e.target.closest("section.shopify-section");
    (btyProductPerformed(t),
      btyComplementaryProducts(t),
      btyHandleEmailInputState(t));
  }),
  document.addEventListener("shopify:section:select", function (e) {
    let t = e.target;
    (btyPhotoswipeHandle(t),
      btyProductPerformed(t),
      btyStickyAddToCart(t),
      btyComplementaryProducts(t),
      btyHandleEmailInputState(t));
  }),
  document.addEventListener("shopify:block:select", function (e) {
    let t = e.target.closest(".shopify-section");
    t &&
      (btyPhotoswipeHandle(t),
      btyStickyAddToCart(t),
      btyComplementaryProducts(t),
      btyHandleEmailInputState(t));
  }));
